import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BellOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M1.613.21l.094.083 22 22a1 1 0 01-1.32 1.497l-.094-.083L17.584 19 3 19c-.273 0-.492-.041-.719-.255l-.098-.103c-.432-.497-.296-.978-.008-1.33.11-.134.199-.203.4-.345.008-.004.275-.189.362-.25.147-.105.274-.2.392-.298.449-.372.671-.698.671-.919V8c0-.674.223-1.321.646-1.937L.293 1.707A1 1 0 011.613.21zM11 19a1 1 0 001.993.117L13 19h2a3 3 0 01-5.995.176L9 19h2zm4.584-2.001L6.108 7.523A1.188 1.188 0 006 8v7.5c0 .554-.175 1.046-.487 1.5l10.071-.001zM12 2c3.706 0 7.828 3.083 7.995 5.829L20 8v5a1 1 0 01-1.993.117L18 13V8c0-1.546-3.22-4-6-4-.844 0-1.739.21-2.61.598a1 1 0 11-.815-1.826C9.692 2.273 10.86 2 12 2z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
BellOffIcon.isCarinaIcon = true;
export default BellOffIcon;
